import React from "react";
import Chart from "react-apexcharts";

const RadarChart = ({ series, categories, themeMode }) => {
  console.log(categories, series);
  const formatCategories = (categories) => {
    return categories.map((category) => {
      const words = category.split(" "); // Kategoriyi kelimelere ayırıyoruz
      const formattedCategory = [];

      // Kelimeleri iki kelime bir arada olacak şekilde ayırıyoruz
      for (let i = 0; i < words.length; i += 2) {
        formattedCategory.push(words.slice(i, i + 2).join(" "));
      }

      return formattedCategory;
    });
  };
  const options = {
    chart: {
      height: 650,
      width: 650,
      type: "radar",
      dropShadow: {
        enabled: true,
        blur: 1,
        left: 1,
        top: 1,
      },
      
      toolbar: {
        show: false, // İndirme düğmesini kaldırmak için
      },
      
      offsetX: 0, // Yatay boşlukları sıfırlar
      offsetY: 0,
      parentHeightOffset: 0,
      grid: {
        padding: {
          top: -1000, // Grafiği yukarı çek
          bottom: 10, // Grafiği aşağı çek
          left: 0,
          right: 0,
        },
      },
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      width: 2,
      // Kesikli çizgi ayarları
      dashArray: [5, 5], // 5px uzunluğunda kesikler ve 5px boşluklar
    },
    fill: {
      opacity: 0, // Radar chart'ın iç kısmını şeffaf yapar
    },
    markers: {
      size: 0,
      colors: ['#fff'],
      strokeColor: '#FF4560',
      strokeWidth: 2,
    },
    
    yaxis: {
        type: 'numeric',
      max: 5,
      min: 0,
      floating: false,
      show: false, // Y eksenini tamamen gizler
      labels: {
        show: true,
        style: {
          color: "#ffffff", // Y-axis etiket metnini beyaz yapıyoruz
        },
        formatter: function (value) {
          return value + "$"; // Y-axis etiketlerine $ işareti ekliyoruz
        },
      },
      axisBorder: {
        show: false, // Y ekseninin sınır çizgisini gizler
      },
      axisTicks: {
        show: false, // Y eksenindeki tick çizgilerini gizler
      },
    },
    xaxis: {
      categories: formatCategories(categories),
      floating: false,
      show: true,
      wordWrapEnabled: true,
      labels: {
        show: true,
        style: {
          colors: Array(categories.length).fill(
            themeMode === "dark" ? "#ffffff" : "#000000"
          ),
          fontSize: "12px", // Yazı boyutunu büyütmek için
          fontWeight: "bold",
        },
        rotate: -45,
      },
      markers: {
        size: 3,
        hover: {
          size: 10,
        },
      },
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      blur: 0, // Blur etkisini kaldır
    },
    dataLabels: {
      enabled: true,
      background: {
          enabled: false,
          borderRadius:2,
      },
      style: {
        colors:   themeMode === "dark" ? ["#ffffff"] : ["#000000"], 
      }
  },
    legend: {
      show: false,
      position: "top",
    },
  };
  return (
    <Chart className="shadow-md rounded-lg pt-2 px-0 pb-0 w-full  lg:w-full min-w-[150px] h-[150px] flex justify-center items-center"
      options={options}
      series={series}
      type="radar"
      height={500}
      width={600}
    />
  );
};

export default RadarChart;
